//============================================================================
// Name        : ICRow.tsx
// Purpose     : Implement custom table row
// Created     : 2019-08-21
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import React from "react";
import { connect } from "react-redux";
import { IUpdateStateAction } from "./actions/editScheduleActions";
import { EditScheduleActions, IReduxReducers } from "./types";

const contentCell = css`
    padding-left: 15px;
    padding-right: 15px;
    text-align: center;
    border: 1px #ccc solid;
    border-bottom: none;
    font-size: 12px;
    height: 40px;
`;

const leftBlueCellContent = css`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
`;

export interface IICActionRow {
    content: JSX.Element | string;
    showDividers?: boolean;
}

class ICRow extends React.Component<IICActionRow> {
    render() {
        const dividers = (this.props.showDividers == undefined) ? false : this.props.showDividers;
        const cellDivider = dividers ? contentCell : css``;
        return (
            <React.Fragment>
                <div css={[cellDivider, leftBlueCellContent]}>
                    <span>{this.props.content}</span>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReduxReducers) => ({
    // schedulerUsers:  state.editSchedule.schedulerUsers
});

const mapDispatchToProps = dispatch => ({
    updateState: (newState: object) => dispatch({
        type: EditScheduleActions.UpdateState,
        payload: newState
    } as IUpdateStateAction)
});

export default connect(mapStateToProps, mapDispatchToProps)(ICRow);
